import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import "./component.css";
import { Container, Row, Col, Spinner } from "react-bootstrap";

const JumlahVarietas = () => {
  const [gradeData, setGradeData] = useState({ GradeA: 0, GradeB: 0, GradeC: 0 });
  const [displayGrade, setDisplayGrade] = useState({ GradeA: 0, GradeB: 0, GradeC: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");

      try {
        const response = await axios.get("https://c-greenproject.org:8000/jumlahvarietas", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setGradeData(response.data);
        setLoading(false);
      } catch (err) {
        setError(err?.response?.data?.msg || "Gagal memuat data.");
        setLoading(false);
      }
    };

    if (user) {
      fetchData();
    }
  }, [user]);
  
  useEffect(() => {
    if (!loading) {
      const duration = 1000; 
      let startTime;

      const animate = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1); 
        const easeOut = 1 - Math.pow(1 - progress, 3); 

        setDisplayGrade({
          GradeA: Math.round(easeOut * gradeData.GradeA),
          GradeB: Math.round(easeOut * gradeData.GradeB),
          GradeC: Math.round(easeOut * gradeData.GradeC),
        });

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };

      requestAnimationFrame(animate);
    }
  }, [loading, gradeData]);

  return (
    <Container className="grade-container">
      <Row className="text-center align-items-center">
        {loading ? (
          <Col xs={12} className="spinner-container">
            <Spinner animation="border" variant="light" />
          </Col>
        ) : error ? (
          <Col xs={12}>
            <p className="text-danger">{error}</p>
          </Col>
        ) : (
          <>
            <Col xs={12} md={4} className="grade-item position-relative">
              <h5><b>Grade A</b></h5>
              <h2><b>{displayGrade.GradeA}</b></h2>
              <p>Ditanam</p>
              <div className="divider d-none d-md-block"></div>
            </Col>
            <Col xs={12} md={4} className="grade-item position-relative">
              <h5><b>Grade B</b></h5>
              <h2><b>{displayGrade.GradeB}</b></h2>
              <p>Ditanam</p>
              <div className="divider d-none d-md-block"></div>
            </Col>
            <Col xs={12} md={4} className="grade-item">
              <h5><b>Grade C</b></h5>
              <h2><b>{displayGrade.GradeC}</b></h2>
              <p>Ditanam</p>
            </Col>
          </>
        )}
      </Row>
    </Container>
  );
};

export default JumlahVarietas;
